<style>

h3{
  text-align: center;
}

.space{
  margin: 20px;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

<h3>What's your email?</h3>
<div class="space">
  <ValidInput bind:value="{email}" valid="{valid}" theme="light" on:changed="{check}" style="background-color: inherit;"></ValidInput>
</div>
<div class="margin small">We'll send you a code to validate your email.</div>

{/if}


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

import ValidInput from "../../components/ValidInput.svelte";

export let show = false;
export let me = null;

let email = "";
let valid = true;
let signupDelayHandle = null;
let lastEmail = "";

$:{
  if (me) set();
}


function set() {
  email = me.email;
}


function check(e) {
  clearTimeout(signupDelayHandle);
  
  if (email == lastEmail) return;
  
  signupDelayHandle = setTimeout( async () => {
    lastEmail = email;
    try {
      if (email == me.email) {
        valid = true;
        return;
      }
      Validate.email(email);
      // await Signup.isEmailUsed(email);
      let res = await auth.post("isEmailUsed", {email: email}, false);
      if (res == "-") throw "email is invalid";
      valid = true;
    } catch (e) {
      valid = false;
      console.log("error:", e);
    }
  }, 450);
  
}


export const save = async () => {
  if (email != me.email) {
    email = Normalize.email(email);
    me.email = email;
    await profile.updateMe( { updateShare: false } );
    let res = await auth.post("saveEmail", {email: email});
    if (res == "+") {
      // enter verification code
      setTimeout( () => dispatch("showVerify"), 1);
    }
  }
}

</script>